/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const COLLECTION_SUBTITLE_STATUSES = ['pending', 'parsed', 'analyzed', 'error'] as const;

export const collectionSubtitleStatusSchema = z.enum(COLLECTION_SUBTITLE_STATUSES);

export type ICollectionSubtitleStatus = z.infer<typeof collectionSubtitleStatusSchema>;
